import { SectionTag } from "./Motion";

const PageHeader = ({ tag, title, sub }) => (
  <div className="relative overflow-hidden border-b border-white/10" data-testid="page-header">
    <div className="noise-overlay" />
    <div className="mx-auto max-w-[1600px] px-5 pb-14 pt-32 md:px-10 md:pb-20 md:pt-40">
      <SectionTag>{tag}</SectionTag>
      <h1 className="mt-4 max-w-5xl font-display text-5xl uppercase leading-[0.95] tracking-tight text-nexa-bone sm:text-6xl lg:text-8xl">
        {title}
      </h1>
      {sub && <p className="mt-6 max-w-2xl text-base leading-relaxed text-nexa-bone/60 md:text-lg">{sub}</p>}
    </div>
  </div>
);

export default PageHeader;
